import axios from "axios";
import {Group} from "three";
import {ModelControler} from "./modelController";
import {Product} from "./Product";
import { EventEmitter } from "events";

export class PriceService{
    public static instance = new PriceService();

    public priceObserve = new EventEmitter();

    private sumPrice:number = 0;

    private PriceService(){

    }

    public getAllProductPrice(): Promise<any>{
        //console.log("PULL price")
        var request:any[] = [];
        request.push(this.addPriceFromDB(ModelControler.instance.getCurrentProduct().product));
        ModelControler.instance.getCurrentProduct().features.forEach((e)=>{
            e.getProductForAddingPrice().forEach((p)=>{
                if(p){
                    request.push(this.addPriceFromDB(p));
                }
            })
        })

        return new Promise((res, rej) => {
            return Promise.all(
                request
            ).then(()=>{
                // console.log("GrillLLLLLLLLLLLLLLLLLLLLLLLLL");
                this.calculatePrice();
                res();
            })
        })
    }

    private addPriceFromDB(product:Product): Promise<any>{
        return new Promise((res, rej) => {
            const cre = btoa(unescape(encodeURIComponent('VisCircle:a5UhmLbigTPA0ZorLvdOwWqMhdt13dxCFZfsxck7')));
            return axios.get("https://cors-anywhere.herokuapp.com/https://schickling-grill.de/api/articles/" + product.getId() + "?useNumberAsId=true" , { headers: {"Authorization" : `Basic ` + cre} })
                .then((result)=>{
                    // console.log(result.data.data.mainDetail.prices[0].price.toFixed(2));
                    let netPrice:number = parseFloat(result.data.data.mainDetail.prices[0].price.toFixed(2));
                    let grossprice = netPrice*119/100;
                    product.setPrice(grossprice);
                    res();
                })
        });
    }

    public calculatePrice(){
        this.sumPrice = ModelControler.instance.getCurrentProduct().product.getPrice();
        ModelControler.instance.getCurrentProduct().features.forEach((e)=>{
            if(e.getProduct()){
                this.sumPrice += e.getProduct().getPrice();
                
            }
        })
        // console.log("calculate price")
        this.priceObserve.emit('priceChange',null, false);
    }

    public getSumPrice():number{
        return this.sumPrice;
    }
}